import(/* webpackMode: "eager" */ "/integromat/app/global-error.tsx")